import { render, staticRenderFns } from "./FicheProfessionnel.vue?vue&type=template&id=64318f09&scoped=true"
import script from "./FicheProfessionnel.vue?vue&type=script&lang=js"
export * from "./FicheProfessionnel.vue?vue&type=script&lang=js"
import style0 from "./FicheProfessionnel.vue?vue&type=style&index=0&id=64318f09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64318f09",
  null
  
)

export default component.exports